// src/pages/mission/components/EquipmentSection.jsx

import React from 'react';
import { getColorClasses } from '../../themeConfig';

const EquipmentSection = ({ 
  title, 
  icon: Icon, 
  iconColor, 
  items, 
  selectedItemId, 
  onSelectItem, 
  gridCols = 'grid-cols-2',
  highlightColor 
}) => {
  return (
    <div className="mb-6">
      <h3 className="text-lg font-bold mb-3 flex items-center gap-2">
        <Icon className={iconColor} size={20} />
        {title}
      </h3>
      <div className={`grid ${gridCols} gap-3`}>
        {items.map(item => {
          const isSelected = selectedItemId === item.id;
          const bgClass = highlightColor 
            ? (isSelected ? getColorClasses(highlightColor, 'alertBg') : 'bg-gray-700')
            : (isSelected ? 'bg-yellow-900/30' : 'bg-gray-700');
          const borderClass = highlightColor
            ? (isSelected ? getColorClasses(highlightColor, 'alertBorder') : 'border-gray-600')
            : (isSelected ? 'border-yellow-500' : 'border-gray-600');
          
          return (
            <button
              key={item.id}
              onClick={() => onSelectItem(item.id)}
              className={`p-4 rounded-lg border-2 transition-all hover:border-gray-500 ${bgClass} ${borderClass}`}
            >
              <div className="text-3xl mb-2">{item.icon}</div>
              <p className="font-bold text-xs mb-1">{item.name}</p>
              {item.damage !== undefined && (
                <div className="flex justify-between text-xs text-gray-400">
                  <span>DMG: {item.damage}</span>
                  <span>ACC: {item.accuracy}%</span>
                </div>
              )}
              {item.defense !== undefined && (
                <div className="flex justify-between text-xs text-gray-400">
                  <span>DEF: {item.defense}</span>
                  <span>MOB: {item.mobility}%</span>
                </div>
              )}
              {item.effect && (
                <p className="text-xs text-gray-400">{item.effect}</p>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default EquipmentSection;